var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "h3",
    { staticClass: "room-title" },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.$store.getters.currentRoomTypeTitleData?.ROOM_TITLE || "")
      ),
      _vm.bedVariant.length ||
      _vm.smokingVariant.length ||
      _vm.adaVariant.length
        ? [_vm._v(", ")]
        : _vm._e(),
      _vm._v(" "),
      _vm.bedVariant.length
        ? [
            _vm.bedOptions.length > 1
              ? _c(
                  "a",
                  {
                    attrs: { title: "Click for room options", href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$store.commit("updateState", [
                          "isVariantDialogVisible",
                          true,
                        ])
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.bedVariant))]
                )
              : _c("span", [_vm._v(_vm._s(_vm.bedVariant))]),
            _vm.smokingVariant.length || _vm.adaVariant.length
              ? [_vm._v(", ")]
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.smokingVariant.length
        ? [
            _vm.smokingVariants.length > 1
              ? _c(
                  "a",
                  {
                    attrs: { title: "Click for room options", href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$store.commit("updateState", [
                          "isVariantDialogVisible",
                          true,
                        ])
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.smokingVariant))]
                )
              : _c("span", [_vm._v(_vm._s(_vm.smokingVariant))]),
            _vm.adaVariant.length ? [_vm._v(", ")] : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.adaVariant.length
        ? [
            _vm.adaVariants.length > 1
              ? _c(
                  "a",
                  {
                    attrs: { title: "Click for room options", href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$store.commit("updateState", [
                          "isVariantDialogVisible",
                          true,
                        ])
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.adaVariant))]
                )
              : _c("span", [_vm._v(_vm._s(_vm.adaVariant))]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }